import { all, call, fork, put, takeEvery,takeLatest,select } from 'redux-saga/effects'
import { CompanyActionTypes, Company } from './types'
import { fetchError, fetchSuccess, selectCompany, companySelected,updateCompany,companyUpdated, editCompany } from './actions'
import { callApi } from '../../utils/api'
import {getCompany} from './selectors'
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://api.opendota.com'

function* handleFetch() {
  try {
    // To call async functions, use redux-saga's `call()`.
    const res = yield call(callApi, 'get', API_ENDPOINT, '/heroes')

    if (res.error) {
      yield put(fetchError(res.error))
    } else {
      yield put(fetchSuccess(res))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(fetchError(err.stack))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* handleSelect(action: ReturnType<typeof selectCompany>) {
  try {
    const company:Company[] = yield select(getCompany);
    const detail: Company |undefined =  company.find(f=>f.id === action.payload); //yield call(callApi, 'get', API_ENDPOINT, `/heroStats/${action.payload}`)
    //const submissionYear = detail === undefined ? [] : detail.roles ; //yield call(callApi, 'get', API_ENDPOINT, `/heroStats/${action.payload}/roles`)

    if (detail === undefined) {
      yield put(fetchError("Record not found"))
    } else {
      yield put(companySelected( detail))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(fetchError(err.stack))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* handleEdit(action: ReturnType<typeof updateCompany>) {
  try {
    //const company:Company[] = yield select(getCompany);
    //const detail: Company |undefined =  company.find(f=>f.id === action.payload); //yield call(callApi, 'get', API_ENDPOINT, `/heroStats/${action.payload}`)
    //const submissionYear = detail === undefined ? [] : detail.roles ; //yield call(callApi, 'get', API_ENDPOINT, `/heroStats/${action.payload}/roles`)

    //if (detail === undefined) {
    //  yield put(fetchError("Record not found"))
    //} else {
      yield put(companyUpdated( action.payload))
   // }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(fetchError(err.stack))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}
// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
  yield takeEvery(CompanyActionTypes.FETCH_REQUEST, handleFetch)
}

function* watchSelectCompany() {
  yield takeLatest(CompanyActionTypes.SELECT_COMPANY, handleSelect)
}
function* watchEditCompany() {
  yield takeLatest(CompanyActionTypes.UPDATE_EDIT, handleEdit)
}
// We can also use `fork()` here to split our saga into multiple watchers.
function* CompanySaga() {
  yield all([fork(watchFetchRequest),fork(watchSelectCompany),fork(watchEditCompany)])
}

export default CompanySaga
